import React, { useEffect, useState } from "react";
import { doc, getDoc, collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import Hero from "../../components/Hero";
import About from "../../components/About";
import Projects from "../../components/Projects";
import Contact from "../../components/Contact";
import Loader from "../../components/Loader";

const HomePage = ({ lang }) => {
  const [heroProfile, setHeroProfile] = useState(null);
  const [personalInfo, setPersonalInfo] = useState(null);
  const [skills, setSkills] = useState([]);
  const [aboutSection, setAboutSection] = useState([]);
  const [projectSection, setProjectSection] = useState([]);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);

      // Hero Profile (documento por idioma)
      const heroSnap = await getDoc(doc(db, "heroProfile", lang));
      setHeroProfile(heroSnap.data());

      // Personal Info (documento por idioma)
      const personalSnap = await getDoc(doc(db, "personalInfo", lang));
      setPersonalInfo(personalSnap.data());

      // Skills (colección por idioma)
      const skillsQ = query(collection(db, "skills"), where("lang", "==", lang));
      const skillsSnap = await getDocs(skillsQ);
      setSkills(skillsSnap.docs.map(doc => doc.data()));

      // Experiences (colección por idioma)
      const aboutSectionSnap = await getDoc(doc(db, "aboutSection", lang));
      setAboutSection(aboutSectionSnap.data());

      const projectSectionSnap = await getDoc(doc(db, "projectsSection", lang));
      setProjectSection(projectSectionSnap.data());

      // Skills (colección por idioma)
      const projectsQ = query(collection(db, "projects"), where("lang", "==", lang));
      const projectsSnap = await getDocs(projectsQ);
      setProjects(projectsSnap.docs.map(doc => doc.data()));

      setLoading(false);
    }
    fetchData();
  }, [lang]);

  if (loading) return <Loader text={lang === 'en' ? 'Loading' : 'Cargando'}/>;

  return (
    <>
      <Hero heroProfile={heroProfile} />
      <About lang={lang} aboutSection={aboutSection} personalInfo={personalInfo} skills={skills} />
      <Projects lang={lang} projectSection={projectSection} projects={projects} />
      <Contact lang={lang} />
    </>
  );
};

export default HomePage;